class ContentApi {
  constructor (ctx) {
    this.ctx = ctx
  }

  getCartTotalComponents = async () => {
    const res = await this.ctx.get('/content/cart_total_component/')

    return res.data
  }

  getFeedbacks = async () => {
    const res = await this.ctx.get('/content/feedback/')

    return res.data
  }

  postFeedback = async (params) => {
    const res = await this.ctx.post('/content/feedback/', params)

    return res.data
  }

  getPageApi = async (slug) => {
    const res = await this.ctx.get(`/content/page_api/${slug}`)

    return res.data
  }

  getArticles = async () => {
    const res = await this.ctx.get('/content/articles/')

    return res.data
  }

  getArticleBySlug = async (slug) => {
    const res = await this.ctx.get(`/content/articles/${slug}/`)

    return res.data
  }
}

export default ContentApi
